const ACTING_HUB_ID_KEY = 'actingHubId';
const ACTING_HUB_NAME_KEY = 'actingHubName';

export const getActingHubId = () => localStorage.getItem(ACTING_HUB_ID_KEY) || '';

export const getActingHubName = () => localStorage.getItem(ACTING_HUB_NAME_KEY) || '';

export const isActingAsHub = () => {
  const role = localStorage.getItem('role');
  return role === 'super_admin' && Boolean(getActingHubId());
};

export const enterHubMode = ({ id, name }) => {
  if (!id) return;
  localStorage.setItem(ACTING_HUB_ID_KEY, String(id));
  localStorage.setItem(ACTING_HUB_NAME_KEY, name || `Hub #${id}`);
  window.dispatchEvent(new Event('acting-hub-changed'));
};

export const exitHubMode = () => {
  localStorage.removeItem(ACTING_HUB_ID_KEY);
  localStorage.removeItem(ACTING_HUB_NAME_KEY);
  window.dispatchEvent(new Event('acting-hub-changed'));
};

/** Full navigation so route trees remount with hub mode. */
export const enterHubModeAndGo = ({ id, name, path = '/dashboard-admin' }) => {
  enterHubMode({ id, name });
  window.location.assign(path);
};

export const exitHubModeAndGo = (path = '/super-admin') => {
  exitHubMode();
  window.location.assign(path);
};
